export type PublicDeviceMode = "hidden" | "code_only";

export type PublicDeviceOverride = {
    deviceUid: string;
    mode: PublicDeviceMode;
};

export function overridesToMap(
    overrides: PublicDeviceOverride[],
): Map<string, PublicDeviceMode> {
    return new Map(overrides.map(o => [o.deviceUid, o.mode]));
}

export function mapToOverrides(
    map: Map<string, PublicDeviceMode>,
): PublicDeviceOverride[] {
    return Array.from(map.entries()).map(([deviceUid, mode]) => ({
        deviceUid,
        mode,
    }));
}

export function countMode(
    map: Map<string, PublicDeviceMode>,
    mode: PublicDeviceMode,
): number {
    let count = 0;
    for (const value of map.values()) {
        if (value === mode) count += 1;
    }
    return count;
}

export function nextMode(
    current: PublicDeviceMode | undefined,
    supportsCodeOnly: boolean,
): PublicDeviceMode | undefined {
    if (supportsCodeOnly) {
        // visible -> code_only -> hidden -> visible
        if (current === undefined) return "code_only";
        if (current === "code_only") return "hidden";
        return undefined;
    }
    // visible <-> hidden
    return current === undefined ? "hidden" : undefined;
}

export function areOverridesEqual(
    a: Map<string, PublicDeviceMode>,
    b: Map<string, PublicDeviceMode>,
): boolean {
    if (a.size !== b.size) return false;
    for (const [uid, mode] of a) {
        if (b.get(uid) !== mode) return false;
    }
    return true;
}
